import { translateProject } from '../i18n/lab';
// Design-experiment portfolio entries for the Lab.
// Add a new object here to publish a new experiment — pages are data-driven.
//
// Each `variant.src` points to a self-contained static HTML file served from
// /public (so the path is absolute from the site root, e.g. "/lab/greenfell/...").

const projects = [
  {
    id: 'orbit-84',
    title: 'ORBIT-84 · 复古终端',
    subtitle: 'ORBIT-84 · Retro Terminal',
    summary: '一台等距视角、线框风格的 80 年代复古电脑。直接打字或点击 3D 键盘输入命令，拨动侧面电源开关看 CRT 开关机动画，插入软盘玩贪吃蛇；还藏着烟花、Hello World 和 exit 滚动字幕等彩蛋。',
    tags: ['3D Toy', 'Retro Computer', 'Easter Eggs'],
    year: '2026',
    iframeAllow: 'fullscreen',
    variants: [{
      id: 'terminal',
      name: '复古终端',
      desc: '键盘输入 · 电源开关 · 软驱贪吃蛇 · 彩蛋',
      src: '/lab/orbit-84/viewer.html',
      accent: '#7dffa0',
    }],
  },
  {
    id: 'pipa-rhythm',
    title: '琵琶曲 · 节奏舞步',
    subtitle: 'Pipa Rhythm · Dance Arrows',
    summary: '跟着《琵琶曲（DJ筱轩版）》130 BPM 的节拍踩上下左右箭头；背景是沿江飞行的水墨山水，按键会带动镜头甩动、拉升与俯冲。箭头可选从上往下或从下往上，支持键盘与触屏和 7 种界面语言。',
    tags: ['Rhythm Game', 'Music Visual', 'Ink Landscape'],
    year: '2026',
    iframeAllow: 'autoplay; fullscreen',
    variants: [{
      id: 'play',
      name: '节奏舞步',
      desc: '简单 · 普通 · 困难 / 键盘与触屏',
      src: '/lab/pipa-rhythm/viewer.html',
      accent: '#ff4b36',
    }],
  },
  {
    id: 'temple-of-heaven',
    title: '天坛 · 祈年殿',
    subtitle: 'Temple of Heaven · Hall of Prayer',
    summary: '旋转、剖切与分解祈年殿，探索三重圆檐、二十八柱和三层圜台；对照演变沿革、李乾朗构造图与梁思成参与修缮的史料。',
    tags: ['3D Exploration', 'Timber Architecture', 'Research Atlas'],
    year: '2026',
    iframeAllow: 'fullscreen',
    variants: [{
      id: 'structure',
      name: '天坛建筑图志',
      desc: '结构探索 · 构造图录 · 演变与修缮',
      src: '/lab/temple-of-heaven/viewer.html',
      accent: '#315e70',
    }],
  },
  {
    id: 'mirror-hand-tracking',
    title: 'Mirror · 手势检测',
    subtitle: 'Hands in Motion',
    summary: '保留摄像头原画，查看手部关节与手势；把手移到头顶区域，再移出，就能“功德 +1”，也可体验人像居中的移轴镜面。画面仅在本机处理。',
    tags: ['Camera', 'Hand Tracking', 'Interactive Mirror'],
    year: '2026',
    iframeAllow: 'camera; fullscreen',
    variants: [{
      id: 'hands',
      name: '手势与镜面',
      desc: '原画叠加 · 手部骨架 · 移轴镜面',
      src: '/lab/mirror-hand-tracking/viewer.html',
      accent: '#d9f88c',
    },{
      id: 'merit',
      name: '功德 +1',
      desc: '手到头顶区域 · 移出区域 · 功德 +1',
      src: '/lab/mirror-hand-tracking/viewer.html?mode=merit',
      accent: '#f2d28b',
    }],
  },
  {
    id: 'china-metro-spacetime',
    title: '地铁时空',
    subtitle: 'Metro · Space & Time',
    summary: '在北京、上海与重庆的三维线网中，查看站名、线路颜色、站间距离与地表高差；按年或月回看开通记录，并跟随 3D 小火车模拟行程、停站与换乘耗时。',
    tags: ['3D Exploration', 'Metro Networks', 'Time Atlas'],
    year: '2026',
    variants: [{
      id: 'metro-atlas',
      name: '地铁时空 · 三城轨道图谱',
      desc: '北京 · 上海 · 重庆 / 高差与时间演变',
      src: '/lab/china-metro-spacetime/viewer.html',
      accent: '#86ead3',
    }],
  },
  {
    id: 'beijing-city-evolution',
    title: '北京城',
    subtitle: 'Beijing · A City Through Time',
    summary:
      '从蓟城到现代北京，切换九个时代，查阅历代城门；展开真实地形、河湖与公园地图，理解城市与西山、平原的关系，并对照梁思成保护设想。',
    tags: ['3D Exploration', 'Urban History', 'Research Atlas'],
    year: '2026',
    variants: [
      {
        id: 'evolution',
        name: '北京城 · 时间里的都城',
        desc: '城市演变 · 城门名录 · 山水地形',
        src: '/lab/beijing-city-evolution/viewer.html',
        accent: '#d8af74',
      },
    ],
  },
  {
    id: 'foguang-temple',
    title: '佛光寺',
    subtitle: 'Foguang Temple · East Hall',
    summary:
      '循着佛光寺东大殿的调查与测绘，探索柱网、梁架、斗栱和屋盖；对照历史图版与实景照片，阅读证据与模型边界。',
    tags: ['3D Exploration', 'Tang Architecture', 'Research Atlas'],
    year: '2026',
    variants: [
      {
        id: 'structure',
        name: '佛光寺建筑图志',
        desc: '东大殿 · 木构探索 · 图纸与影像',
        src: '/lab/foguang-temple/viewer.html',
        accent: '#c88761',
      },
    ],
  },
  {
    id: 'yingxian-pagoda',
    title: '应县木塔',
    subtitle: 'Yingxian Wooden Pagoda',
    summary:
      '参考梁思成测绘资料，以三维概念释义探索五明四暗、柱网梁架与楼梯通行；并列阅读历史图纸和实拍影像。',
    tags: ['3D Exploration', 'Timber Architecture', 'Research Atlas'],
    year: '2026',
    variants: [
      {
        id: 'structure',
        name: '木构 · 应县',
        desc: '结构探索 · 楼梯与通行 · 测绘档案',
        src: '/lab/yingxian-pagoda/viewer.html',
        accent: '#8f4938',
      },
    ],
  },
  {
    id: 'rust-and-roam',
    title: '《旧车远行》',
    subtitle: 'Rust & Roam',
    summary:
      '一款常驻 macOS 桌面的像素公路挂机游戏。记录旧车、旅途、能源与载货系统的视觉探索，以及可直接用于制作的分层原稿。',
    tags: ['Desktop Game', 'Pixel Art', 'Layered Parallax'],
    year: '2026',
    variants: [
      {
        id: 'portfolio',
        name: '作品集 · Portfolio',
        desc: '设计演进 · 分层原稿 · 视差场景',
        src: '/lab/rust-and-roam/index.html',
        accent: '#d99742',
      },
    ],
  },
  {
    id: 'greenfell',
    title: '《青麓余晖》',
    subtitle: 'Greenfell at Dusk',
    summary:
      '一款星露谷血脉的像素经营 / 生活模拟游戏的简介长页。同一份内容、三个完全不同的视觉方向，用来对比挑选最终风格。',
    tags: ['Game Landing', 'Pixel Art', '3 Directions'],
    year: '2026',
    // The first variant doubles as the card cover preview.
    variants: [
      {
        id: 'cozy',
        name: 'A · Cozy Sundown',
        desc: '温馨黄昏 · 羊皮纸暖底 · 星露谷血脉',
        src: '/lab/greenfell/cozy-sundown.html',
        accent: '#c9803f',
      },
      {
        id: 'twilight',
        name: 'B · Twilight Glow',
        desc: 'JRPG 暮色 · 金色描边 · 氛围渐变',
        src: '/lab/greenfell/twilight-glow.html',
        accent: '#b48a3a',
      },
      {
        id: 'arcade',
        name: 'C · Arcade Cartridge',
        desc: '街机卡带 · CRT 霓虹 · 扫描线',
        src: '/lab/greenfell/arcade-cartridge.html',
        accent: '#ff4dd2',
      },
    ],
  },
];

const labProjects = projects.map(translateProject);

export const getLabProject = (id) => labProjects.find((p) => p.id === id);

export default labProjects;
